import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["MaintenanceCycle"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getMaintenanceCycle: build.query<
        GetMaintenanceCycleApiResponse,
        GetMaintenanceCycleApiArg
      >({
        query: () => ({ url: `/MaintenanceCycle` }),
        providesTags: ["MaintenanceCycle"],
      }),
      getMaintenanceCycleByName: build.query<
        GetMaintenanceCycleByNameApiResponse,
        GetMaintenanceCycleByNameApiArg
      >({
        query: (queryArg) => ({ url: `/MaintenanceCycle/${queryArg}` }),
        providesTags: ["MaintenanceCycle"],
      }),
      putMaintenanceCycleByName: build.mutation<
        PutMaintenanceCycleByNameApiResponse,
        PutMaintenanceCycleByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/MaintenanceCycle/${queryArg.name}`,
          method: "PUT",
          body: queryArg.maintenanceCycleDto,
        }),
        invalidatesTags: ["MaintenanceCycle"],
      }),
      deleteMaintenanceCycleByName: build.mutation<
        DeleteMaintenanceCycleByNameApiResponse,
        DeleteMaintenanceCycleByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/MaintenanceCycle/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["MaintenanceCycle"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as maintenanceCycleApi };
export type GetMaintenanceCycleApiResponse =
  /** status 200 OK */ MaintenanceCycleDto[];
export type GetMaintenanceCycleApiArg = void;
export type GetMaintenanceCycleByNameApiResponse =
  /** status 200 OK */ MaintenanceCycleDto;
export type GetMaintenanceCycleByNameApiArg = string;
export type PutMaintenanceCycleByNameApiResponse = /** status 200 OK */ void;
export type PutMaintenanceCycleByNameApiArg = {
  name: string;
  maintenanceCycleDto: MaintenanceCycleDto;
};
export type DeleteMaintenanceCycleByNameApiResponse = unknown;
export type DeleteMaintenanceCycleByNameApiArg = string;
export type MaintenanceCycleDto = {
  name: string;
  comment?: string | null;
  isUsed: boolean;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export const {
  useGetMaintenanceCycleQuery,
  useLazyGetMaintenanceCycleQuery,
  useGetMaintenanceCycleByNameQuery,
  useLazyGetMaintenanceCycleByNameQuery,
  usePutMaintenanceCycleByNameMutation,
  useDeleteMaintenanceCycleByNameMutation,
} = injectedRtkApi;
